import { render, staticRenderFns } from "./GroupOperatorSlot.vue?vue&type=template&id=d5ba9586&"
import script from "./GroupOperatorSlot.vue?vue&type=script&lang=js&"
export * from "./GroupOperatorSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSelect} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSelect})
